<template>
  <div class="cr-toolbar db-toolbar">
    <competence-picker class="cr-toolbar-field db-field-competence"
                       label="Competência" :value="value.competence"
                       @input="set('competence', $event)"/>

    <div class="cr-toolbar-field db-field-insurance form-group">
      <label class="form-label">Convênio</label>
      <select class="form-select" :value="value.insurancePlanId"
              @change="set('insurancePlanId', $event.target.value)">
        <option value="">Todos os convênios</option>
        <option v-for="item in insurances" :value="item.id" :key="item.id">{{ item.name }}</option>
      </select>
    </div>

    <div class="cr-toolbar-actions db-field-actions">
      <button class="btn btn-link btn-sm db-clear" :disabled="loading" @click="$emit('clear')">
        Limpar filtros
      </button>
      <button class="btn btn-secondary btn-icon btn-icon-left db-search"
              :class="{loading}" :disabled="loading" @click="$emit('search')">
        <fa-icon :icon="['fal', 'search']"/>Pesquisar
      </button>
    </div>
  </div>
</template>

<script>
import CompetencePicker from '@/app/billing/batch/components/CompetencePicker.vue';

export default {
  components: {
    CompetencePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    insurances: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    set(key, newValue) {
      this.$emit('input', { ...this.value, [key]: newValue });
    },
  },
};
</script>
